import { classNames } from '@fold-dev/core'
import React, { forwardRef } from 'react'
import { stopEvent } from '../../helpers'

export type ActionButtonProps = {
    variant?: 'accent' | 'default'
    border?: boolean
    children: any
    onClick: (e) => void
    className?: string
    disabled?: boolean
    style?: any
}

export const ActionButton = forwardRef((props: ActionButtonProps, ref: any) => {
    const { border, variant = 'default', children, onClick, disabled, style = {} } = props
    const className = classNames(
        {
            'f-action-button': true,
            'f-buttonize-outline': true,
            'f-row': true,
            'has-border': border,
            'is-accent': variant == 'accent',
        },
        [props.className]
    )

    return (
        <button
            ref={ref}
            disabled={disabled}
            tabIndex={0}
            className={className}
            onClick={(e) => {
                if (disabled) true
                stopEvent(e)
                onClick(e)
            }}
            style={style}>
            {children}
        </button>
    )
})
